(function ($) {
  $(window).on('load', function () {
    setTimeout(function () {
      let tabLength = ($('.vertical-tab .tabs-wrapper').length) - 1,
        randomNum = Math.floor(Math.random() * tabLength);
      $('.vertical-tab .card > a').html("Read More");
      if (randomNum == -1) {
        $('.vertical-tab .tabs-wrapper').eq(0).addClass('active');
      } else {
        $('.vertical-tab .tabs-wrapper').eq(randomNum).addClass('active');
      }
      $('.vertical-tab .tabs-wrapper.active .tab-content').clone().appendTo(' body .vertical-tab .tab-content-wrap');
      if ($(window).width() < 768) {
        if ($('.vertical-tab').hasClass('author-vertical-tab')) {
          $(' .vertical-tab .tabs-wrapper h4').removeClass('wow fadeInLeft').removeAttr('data-wow-duration').css('visibility', 'visible');
        }
        $('body .vertical-tab .tabs-wrapper.active .tab-content').slideDown();
      }
    }, 300);
    //click functionality
    $(document).on('click','.vertical-tab .tabs-wrapper .tab-item', function () {
      if ($(window).width() < 768) {
        $(this).parent().toggleClass('active');
      } else {
        $(this).parent().addClass('active');
      }
      $(this).parent().siblings().removeClass('active');
      $('body .vertical-tab .tab-content-wrap ').empty();
      $('.vertical-tab .tabs-wrapper.active .tab-content').clone().appendTo(' body .vertical-tab .tab-content-wrap ');
      if ($(window).width() < 768) {
        if ($(this).parent()) {
        }
        $('body .vertical-tab .tabs-wrapper.active .tab-content').slideDown();
        $('body .vertical-tab .tabs-wrapper').not('.active').find(' .tab-content').slideUp();
      }
      var outerHeight, stickyHeihgt, navHeight;
      if ($('.sticky-nav').length > 0) {
        stickyHeihgt = $('.sticky-nav').outerHeight();
      } else {
        stickyHeihgt = 0;
      }
      if ($('header').length > 0) {
        navHeight = $('header').outerHeight();
      } else {
        navHeight = 0;
      }
      outerHeight = stickyHeihgt + navHeight;
      var winTop = $(window).scrollTop();
      setTimeout(function () {
        if ($('body .vertical-tab .tabs-wrapper.active').length > 0) {
          var scTop = $('body .vertical-tab .tabs-wrapper.active').offset().top - outerHeight;
          var totHeight = $('body .vertical-tab .tabs-wrapper.active').offset().top + outerHeight;

          if (winTop > totHeight) {
            $('html, body').animate({
              scrollTop: scTop
            }, 400);
          }
        }
      }, 380);
    });
  });
  $(window).on('resize orientationchange', function () {
    setTimeout(function () {
      if ($(window).width() < 768) {
        if ($('.vertical-tab').hasClass('author-vertical-tab')) {
          $(' .vertical-tab .tabs-wrapper h4').removeClass('wow fadeInLeft').removeAttr('data-wow-duration').css('visibility', 'visible');
        }
        $('body .vertical-tab .tabs-wrapper.active .tab-content').slideDown();
        $('body .vertical-tab .tabs-wrapper').not('.active').find('.tab-content').slideUp();
      }
    }, 500);
  });
})(jQuery);